import React from "react";
import { StoryElement } from "@quintype/components";
import "./promotional-message.m.css";

function PromotionalMessage({ story }) {
  const cards = story.cards;
  const promotionalElement = cards?.map((card) =>
    card["story-elements"]?.filter((element) => element?.metadata?.["promotional-message"] === true || element?.metadata?.["promotional-message"] === "true")
  );
  const filteredPromotionalElement = promotionalElement?.filter((element) => element.length > 0);

  if (filteredPromotionalElement.length > 0 && filteredPromotionalElement[0].length > 0) {
    return (
      <div styleName="wrapper" id="promotional-message">
        {promotionalElement?.map((storyelement) =>
          storyelement?.map((element, idx) => (
            <div key={idx}>
              <StoryElement element={element} key={element.id} story={story} />
            </div>
          ))
        )}
      </div>
    );
  }

  return null;
}

export default PromotionalMessage;
